// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer__footer--3ZzcZ","insideContent":"footer__insideContent--2Dv7-","submit":"footer__submit--16uPJ"};